function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1a {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Moviles",
  transform: "translate(-426.596 -326.771)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_88",
  "data-name": "Grupo 88",
  transform: "translate(426.596 326.771)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_87",
  "data-name": "Grupo 87"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_47",
  "data-name": "Trazado 47",
  className: "cls-1a",
  d: "M443.309,326.771H428.585a2.055,2.055,0,0,0-1.989,2.11v1.393h18.7v-1.393A2.055,2.055,0,0,0,443.309,326.771ZM438.7,329.69h-5.5a.585.585,0,0,1,0-1.167h5.5a.585.585,0,0,1,0,1.167Zm3.85,0H442a.585.585,0,0,1,0-1.167h.55a.585.585,0,0,1,0,1.167Z",
  transform: "translate(-426.596 -326.771)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_90",
  "data-name": "Grupo 90",
  transform: "translate(434.78 355.684)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_89",
  "data-name": "Grupo 89"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_48",
  "data-name": "Trazado 48",
  className: "cls-1a",
  d: "M437.246,357.711H435.8a.444.444,0,0,0-.443.443v.282a.443.443,0,0,0,.443.443h1.449a.444.444,0,0,0,.443-.443v-.282A.444.444,0,0,0,437.246,357.711Z",
  transform: "translate(-435.354 -357.711)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_92",
  "data-name": "Grupo 92",
  transform: "translate(426.598 331.441)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_91",
  "data-name": "Grupo 91"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_19",
  "data-name": "Rect\\xE1ngulo 19",
  className: "cls-1a",
  width: 18.7,
  height: 21.052
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_94",
  "data-name": "Grupo 94",
  transform: "translate(426.598 353.933)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_93",
  "data-name": "Grupo 93"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_49",
  "data-name": "Trazado 49",
  className: "cls-1a",
  d: "M426.6,355.96v3.727a2.055,2.055,0,0,0,1.988,2.111h14.724a2.055,2.055,0,0,0,1.989-2.111V355.96Zm11.55,2.476a1.567,1.567,0,0,1-1.517,1.61h-1.366a1.567,1.567,0,0,1-1.517-1.61v-.282a1.567,1.567,0,0,1,1.517-1.61h1.366a1.567,1.567,0,0,1,1.517,1.61Z",
  transform: "translate(-426.598 -355.96)"
}))));

function SvgMoviles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.702,
    height: 33,
    viewBox: "0 0 18.702 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoviles);
export default __webpack_public_path__ + "static/media/Moviles.f19a69b1.svg";
export { ForwardRef as ReactComponent };